/* eslint-disable-next-line camelcase */
import { DM_Sans, IBM_Plex_Mono, Sora } from 'next/font/google';

import { createTheme } from '@craft/ui/util';

declare module 'notistack' {
  interface VariantOverrides {
    error: {
      dismissable?: boolean;
      title?: string;
    };
    info: {
      dismissable?: boolean;
      title?: string;
    };
    success: {
      dismissable?: boolean;
      title?: string;
    };
    warning: {
      dismissable?: boolean;
      title?: string;
    };
  }
}

export const SoraFont = Sora({
  display: 'swap',
  fallback: ['Helvetica', 'Arial', 'sans-serif'],
  subsets: ['latin'],
  weight: ['300', '400', '500', '600', '700'],
});

export const DMSansFont = DM_Sans({
  display: 'swap',
  fallback: ['Helvetica', 'Arial', 'sans-serif'],
  subsets: ['latin'],
  weight: ['300', '400', '500', '600', '700'],
});

export const PtFont = IBM_Plex_Mono({
  display: 'swap',
  fallback: ['Helvetica', 'Arial', 'sans-serif'],
  subsets: ['latin'],
  weight: ['400', '500', '600', '700'],
});

export const theme = createTheme({
  fontFamilies: {
    body: DMSansFont.style.fontFamily,
    heading: SoraFont.style.fontFamily,
    monospace: PtFont.style.fontFamily,
  },
});
